import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { primary_nav, TITLE } from './../../_DATA.json';
import { setMenuState } from './../../redux/actions';
import { breakpoints } from './../../styles/theme.json';
import Hamburger from './Hamburger';
import SocialIcons from './../SocialIcons';
import HeaderDropNav from  './../HeaderDropNav';

const HeaderNav = (props) => {
  const navLinks = primary_nav.map((item, i) =>
    <li className={'menu-item'} key={item.page + i}>
      <NavLink to={item.link} className="top-nav-link" onClick={e => props.menuDrop(e)}>
        <span dangerouslySetInnerHTML={{ __html:item.page }}></span>
      </NavLink>
    </li>
  );
  
  const MobileNavigation = () => (
    <nav className={props.isOpen ? 'mobile-nav active' : 'mobile-nav' }>
      <Hamburger clickState={props.isOpen} onClick={e => props.menuDrop(e)}/>
      <div className="mobile-menu-wrapper">
        <ul className="mobile-menu">
          {navLinks}
        </ul>
        <SocialIcons/>
      </div>
    </nav>
  );
  
  const DesktopNavigation = () => (
    <nav className="desktop-nav">
      <HeaderDropNav currentPage={props.navLocation} onClick={e => props.menuDrop(e)} linkClass={'top-nav-link'}/>
      <div className="nav-dropdown">
        <ul className="desk-menu">
          {navLinks}
        </ul>
      </div>
    </nav>
  );
  
  return (
    <Fragment>
      <div className="inner-header">
        <div id="logo">
          <Link to={'/'}><span>{TITLE}</span></Link>
        </div>
        {(props.window_width >= breakpoints.desktop)
          ? <DesktopNavigation/>
          : <MobileNavigation/>
        }
      </div>
      {(props.window_width >= breakpoints.desktop) && <div className="header-bg-gradient"/>}
      <div className="header-bg"/>
    </Fragment>
  );
};

export default connect(
  state => ({
    navLocation: state.nav_location,
    headerStyle: state.header_style,
    scrollDirection: state.scroll_direction,
    belowHero: state.scroll_state.cat_menu_wrapper,
    isOpen: state.menu_state,
    window_width: state.window_dimensions.window_width
  }),
  dispatch => ({
    menuDrop: () => dispatch(setMenuState())
  })
)(HeaderNav);



// WEBPACK FOOTER //
// ./src/components/header/HeaderNav.js